import { LazyLoadImage } from 'react-lazy-load-image-component';
import { renderImageClickHandler } from 'react-photo-gallery';
import { Figure, Stack } from 'react-bootstrap';
import Pannellum, { PannellumRef } from 'rc-pannellum';

type Property = {
  photo: {
    id?: number;
    src: string;
    width?: number;
    height?: number;
    link?: string;
    company?: string;
    title?: string;
    type?: number;
  };
  direction?: string;
  index?: number;
  left?: number | string;
  top?: number | string;
  onClick?: renderImageClickHandler | null;
  className?: string;
};

const PhotoHomeComponent = (props: Property): JSX.Element => {
  const cont: { [key: string]: string | number } = {};
  if (props.direction === 'column') {
    cont.position = 'absolute';
    cont.left = props.left ?? 0;
    cont.top = props.top ?? 0;
  }

  function randomNumber(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  let details = '';
  if (props.photo.title && props.photo.company)
    details = props.photo.title + ' / ' + props.photo.company;
  else if (props.photo.title) {
    details = props.photo.title;
  } else if (props.photo.company) {
    details = props.photo.company;
  }

  const url: string = process.env.REACT_APP_API_URL ?? '';

  return (
    <div
      key={`photo-index-${props.index}`}
      onClick={(e) => {
        if (!props.onClick) return;
        props.onClick(e, {
          index: props.index ?? 0
        });
      }}
      className={`item-img fade-in-image ` + (props.className ?? '')}
      style={{
        height: props.photo.height,
        width: props.photo.width,
        ...cont
      }}
    >
      <Stack gap={2} className="h-100">
        <div
          className="shine img-wrapper"
          style={{
            width: '100%',
            height: '100%',
            animationDuration: randomNumber(1, 3) + 's'
          }}
        >
          {props.photo.type === 1 ? (
            <LazyLoadImage alt={''} src={props.photo.src} className="h-100 w-100 image inner-img" />
          ) : (
            <Pannellum
              className="viewer gallery-item"
              autoLoad={true}
              panorama={`${url}works/${props.photo.id}/file`}
              style={{ height: props.photo.height, width: props.photo.width }}
              clickInfo={false}
            />
          )}
        </div>
        <Figure.Caption className="details">{details}</Figure.Caption>
      </Stack>
    </div>
  );
};

export default PhotoHomeComponent;
